import { Component, OnInit, OnChanges, SimpleChange } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { LoginRequest, InitAuthState } from '../../stores/auth/auth.actions';
import { AuthState } from '../../stores/auth/auth.state';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'leagueplay-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Select(AuthState.loading) loading$: Observable<boolean>;
  @Select(AuthState.error) error$: Observable<boolean>;

  public showError$: Observable<boolean> = combineLatest(
    this.loading$,
    this.error$
  ).pipe(
    map(([loading, error]) => {
      return !loading && error;
    })
  );

  public username: string = 'unreal';
  public password: string = 'password';

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.store.dispatch(new InitAuthState());

    // todo: dispose of this
    this.store.select(AuthState.user).subscribe(user => {
      if (user) {
        this.router.navigateByUrl('/');
      }
    });
  }

  submit() {
    if (this.username && this.password) {
      const params = this.route.snapshot.queryParams;
      this.store.dispatch(
        new LoginRequest(this.username, this.password, params.returnUrl)
      );
    }
  }

  keydown(event) {
    if (event.keyCode === 13) {
      this.submit();
    }
  }
}
